import script from "./BaseBranchAvailability.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseBranchAvailability.vue?vue&type=script&setup=true&lang=ts"

import "./BaseBranchAvailability.vue?vue&type=style&index=0&id=5b636970&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b636970"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField});
